module.exports = __webpack_public_path__ + "static/media/Ashley A.4cae28de.png";